/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Demos_Title5Inputs */

const en_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly demos`)
};

const ar_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عروض أسبوعية`)
};

const bn_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাপ্তাহিক ডেমো`)
};

const de_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wöchentliche Demos`)
};

const es_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demos semanales`)
};

const fr_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démos hebdomadaires`)
};

const pt_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demos semanais`)
};

const zh_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每周演示`)
};

const tr_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haftalık demolar`)
};

const ru_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Еженедельные демо`)
};

const pl_svc_mvp_sprint_demos_title5 = /** @type {(inputs: Svc_Mvp_Sprint_Demos_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cotygodniowe dema`)
};

/**
* | output |
* | --- |
* | "Weekly demos" |
*
* @param {Svc_Mvp_Sprint_Demos_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_demos_title5 = /** @type {((inputs?: Svc_Mvp_Sprint_Demos_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Demos_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_demos_title5(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_demos_title5(inputs)
	if (locale === "de") return de_svc_mvp_sprint_demos_title5(inputs)
	if (locale === "es") return es_svc_mvp_sprint_demos_title5(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_demos_title5(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_demos_title5(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_demos_title5(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_demos_title5(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_demos_title5(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_demos_title5(inputs)
	return en_svc_mvp_sprint_demos_title5(inputs)
});
export { svc_mvp_sprint_demos_title5 as "svc_mvp-sprint_DEMOS_title" }